import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';

class StatusRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { value, data, showDispositionsDetail } = this.props;
    if (!data) {
      return null;
    }
    const { tracking } = data;
    const loaded = tracking !== undefined;
    if (!loaded) {
      return (<Fa name="spinner" spin className="text-muted" />);
    }
    if (tracking.submitted) {
      return (
        <a
          href=""
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            showDispositionsDetail(data);
          }}
        >
          {value}
        </a>
      );
    }
    return (<span className="text-muted">{value}</span>);
  }
}

StatusRenderer.propTypes = {
  value: PropTypes.string,
  data: PropTypes.shape({
    _id: PropTypes.string.isRequired,
  }),
  showDispositionsDetail: PropTypes.func,
};
StatusRenderer.defaultProps = {
  value: null,
  data: null,
  showDispositionsDetail: () => {},
};

export default StatusRenderer;
